import AxiosClient from '@/repositories/clients/axiosCsExternal'

const resource = '/uploads'

const findOne = (uploadId, queryParams = '', organization) => AxiosClient.get(
  `${resource}/${uploadId}?${queryParams}`, { headers: { organization } }
)

const deleteOne = (uploadId, organization) => AxiosClient.delete(
  `${resource}/${uploadId}`, { headers: { organization } }
)

const create = (payload, organization) => AxiosClient.post(
  `${resource}`, payload, { headers: { organization, 'content-type': 'multipart/form-data' } }
)

const createPresignedPost = (payload, organization) => AxiosClient.post(
  `${resource}/createPresignedPost`, payload, { headers: { organization } }
)

export {
  findOne,
  deleteOne,
  create,
  createPresignedPost
}
